import {
    ImageBackground,
    Pressable,
    ScrollView,
    Text,
    TouchableOpacity,
    View,
    ActivityIndicator,
    TextInput
} from "react-native";
import {useState} from "react";
import {createNativeStackNavigator} from "@react-navigation/native-stack";
import { FormItemContainer } from "../common/FormItemContainer";
import {styles, TAB_BAR_HEIGHT} from "../common/styles";
import {i18n} from "../common/localization";
import {WhiteViewHeader} from "../common/WhiteViewHeader";
import {KeyboardAvoidingViewWrapper} from "../common/KeyboardAvoidingViewWrapper";
import {DatePickerComponent as DatePicker} from "../common/DatePickerComponent";
import {InfoModal} from "../common/InfoModal";

import {MenuNavigator} from "../menu/MenuNavigator";
import BookedReservations from "./BookedReservations";
import {fetchAvailableSlots, bookSlot} from '../common/api';
import { formatDateForApi } from '../common/date';
import { BookingListBox } from './BookingListBox';
import TriangleIcon from "../icons/TriangeIcon";
import menuButton from "../assets/menu-button.jpg";
import restaurantBg from "../assets/restaurant-bg.png";

import { Select } from "native-base";

import gymImage from "../assets/gym-image.jpg";
import gymBg from "../assets/gym-bg.png";

import saunaBg from "../assets/sauna-bg.png";
import saunaImage from "../assets/sauna-image.jpg";

const Stack = createNativeStackNavigator();

export const reservationType = {
    GYM: "GYM",
    SAUNA: "SAUNA",
    RESTAURANT: "RESTAURANT",
};

export const Reservation = ({ type }) => {
    return (
        <Stack.Navigator>
            <Stack.Screen
                name="Home"
                options={{ headerShown: false }}
            >
                {(props) => <ReservationHome {...props} type={type} />}
            </Stack.Screen>
            <Stack.Screen
                name="MenuNavigator"
                component={MenuNavigator}
                options={{ headerShown: false }}
            />
        </Stack.Navigator>
    )
}

const ReservationHome = ({ navigation, type }) => {
    // Date time picker
    const [date, setDate] = useState(new Date());
    const [mode, setMode] = useState('date');
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [isCreating, setIsCreating] = useState(false);

    // Available slots
    const [slots, setSlots] = useState([]);
    const [loadingSlots, setLoadingSlots] = useState(false);
    const [errorSlots, setErrorSlots] = useState(null);
    const [hasSearched, setHasSearched] = useState(false);

    const [participants, setParticipants] = useState(1);
    const [notes, setNotes] = useState('');


    // Error modal
    const [errorModalVisible, setErrorModalVisible] = useState(false);

    // Sets the mode of datepicker (date/time)
    const showMode = (currentMode) => {
        setShowDatePicker(true);
        setMode(currentMode);
    };

    // Shows datepicker
    const showDatepicker = () => {
        showMode('date');
    };

    // API call for available slots
    const onPressSearch = async () => {
         setLoadingSlots(true);
        setHasSearched(true);
        setSlots([]);
        try {
        const isoDate = formatDateForApi(date);
        const data    = await fetchAvailableSlots(type, isoDate);

        const filtered =
             type === reservationType.RESTAURANT
               ? data.filter(l => Number(l?.TotalBookings ?? 0) === 0 &&
                                  Number(l?.MaxPartecipants ?? 0) >= Number(participants))
               : data;
            setSlots(filtered);
        } catch (e) {
        setErrorModalVisible(true);
        } finally {
        setLoadingSlots(false);
        }
    };

    // Closes results modal
    function onPressClose() {
        setErrorModalVisible(false);
    }

    // Opens Menu view
    function onPressMenu() {
        navigation.navigate('MenuNavigator');
    }

    let title, image, bg;
    switch (type) {
        case reservationType.RESTAURANT:
            title = i18n.t("restaurant");
            bg = restaurantBg;
            image = menuButton;
            break;
        case reservationType.GYM:
            title = i18n.t("gym");
            bg = gymBg;
            image = gymImage;
            break;
        case reservationType.SAUNA:
            title = i18n.t("sauna");
            bg = saunaBg;
            image = saunaImage;
            break;
    }

    const composeRestaurantNotes = (participants, rawNotes) => {
      const n = String(participants).trim();
      const notes = (rawNotes ?? '').trim();
      const lines = [`Partecipanti al tavolo: ${n}`];
      if (notes) lines.push('Note: ' + notes);
      return lines.join('\n');
    };

    return (
        <View style={styles.container}>
            <ImageBackground source={bg} resizeMode="contain" style={{...styles.whiteViewBgImageContainer, width: 271, height: 118}} />
            <View style={{...styles.whiteViewContainer, paddingBottom: TAB_BAR_HEIGHT}}>
                <WhiteViewHeader onPressBack={isCreating ? () => setIsCreating(false) : undefined}/>
                <KeyboardAvoidingViewWrapper style={{flex: 1}}>
                    <View style={{flex: 1}}>
                        <ScrollView style={styles.whiteViewScrollView} contentContainerStyle={{ paddingBottom: isCreating ? 0 : 100 }}>
                            <Text style={styles.whiteViewTitleText}>
                                { isCreating ? i18n.t("newReservation") : title }
                            </Text>
                            <View style={styles.whiteViewScrollViewInnerContainer}>
                                <ImageBackground source={image} resizeMode="cover" style={styles.restaurant.menuButton} >
                                    { type === reservationType.RESTAURANT &&
                                        <Pressable onPress={onPressMenu} style={styles.restaurant.menuButtonContainer}>
                                            <Text style={styles.restaurant.menuButtonText}>{i18n.t("menu")}</Text>
                                        </Pressable>
                                    }
                                </ImageBackground>
                                { type === reservationType.RESTAURANT &&
                                    <TriangleIcon color="#EA1631" style={styles.colorTriangle} />
                                }
                            </View>

                            {!isCreating ? (
                                <View style={styles.whiteViewScrollViewInnerContainer2}>
                                    <Text style={styles.restaurant.reservationTitle}>{i18n.t("reservations")}</Text>
                                    <BookedReservations type={type} />
                                </View>
                            ) : (
                                <View style={styles.whiteViewScrollViewInnerContainer2}>
                                    <FormItemContainer title={i18n.t("dateReservation")}>
                                        <TouchableOpacity onPress={showDatepicker}>
                                            <Text style={styles.restaurant.formItemValue}>{date.toLocaleDateString(i18n.locale)}</Text>
                                        </TouchableOpacity>
                                    </FormItemContainer>
                                   {type === reservationType.RESTAURANT && (
                                     <FormItemContainer title={i18n.t("participants")}>
                                       <Select
                                         selectedValue={String(participants)}
                                         onValueChange={(val) => setParticipants(Number(val))}
                                         variant="unstyled"
                                         dropdownIcon={<></>}
                                         minWidth="100%"
                                         fontFamily="ViaodaLibre-Regular"
                                         fontSize="40"
                                         lineHeight="40"
                                         color="#242424"
                                         height="16"
                                         p="0"
                                         mt="5"
                                       >
                                         {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
                                           <Select.Item key={n} label={`${n}`} value={`${n}`} />
                                         ))}
                                       </Select>
                                     </FormItemContainer>
                                   )}

                                    <View style={{ marginTop: 24 }}>
                                        <Pressable onPress={onPressSearch} style={styles.button}>
                                            <Text style={styles.buttonText}>{i18n.t("search")}</Text>
                                        </Pressable>
                                    </View>

                                    {loadingSlots && <ActivityIndicator style={styles.reservationsBox} />}
                                    {errorSlots && <Text style={styles.noReservationsText}>{errorSlots}</Text>}
                                    {!loadingSlots && !errorSlots && hasSearched && (
                                        <BookingListBox
                                            isBooking={true}
                                            data={slots}
                                            title={i18n.t('availableSlots')}
                                            actionLabel={i18n.t('book')}
                                             isRestaurant={type === reservationType.RESTAURANT}
                                             onItemAction={async (item, notesFromModal) => {
                                               const isoDate = formatDateForApi(date);
                                               const notesCombined =
                                                 type === reservationType.RESTAURANT
                                                   ? composeRestaurantNotes(participants, notesFromModal)
                                                   : null;
                                               await bookSlot(item.ID, isoDate, notesCombined);
                                               onPressSearch();
                                               setIsCreating(false);
                                             }}
                                        />
                                    )}
                                </View>
                            )}
                        </ScrollView>

                        {!isCreating && (
                            <View style={styles.floatingButtonContainer}>
                                <Pressable onPress={() => setIsCreating(true)} style={styles.button}>
                                    <Text style={styles.buttonText}>{i18n.t("newReservation")}</Text>
                                </Pressable>
                            </View>
                        )}
                    </View>
                </KeyboardAvoidingViewWrapper>
            </View>
            <InfoModal
                visible={errorModalVisible}
                onPressClose={onPressClose}
                isError={true}
                text={i18n.t('slotSearchFail')}
                />
            <DatePicker
                modal
                open={showDatePicker}
                date={date}
                mode={mode}
                theme={'light'}
                locale={i18n.locale}
                is24hourSource={'locale'}
                minimumDate={new Date()}
                title={null}
                confirmText={i18n.t('confirm')}
                cancelText={i18n.t('cancel')}
                textColor={'#000'}
                onConfirm={(d) => { setShowDatePicker(false); setDate(d); }}
                onCancel={() => { setShowDatePicker(false); }}
            />
        </View>
    )
}
